import { render } from "./LLoading.vue?vue&type=template&id=2a23d206"
import script from "./LLoading.vue?vue&type=script&lang=js"
export * from "./LLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__